import { Injectable } from '@angular/core';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption, SimpleConfigBaseFilter } from 'gung-list';
import { ColmecPartnerAgreement, ColmecPartnerAgreementsService } from './colmec-partner-agreements.service';
import { Observable, first, forkJoin, map, of, switchMap } from 'rxjs';
import { ColmecPartnerAgreementsListViewComponent } from '../components/colmec-partner-agreements-list-view/colmec-partner-agreements-list-view.component';
import { Customer, CustomerService } from 'gung-standard';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ColmecPartnerAgreementsListConfigService implements ConfigService<ColmecPartnerAgreement> {
  constructor(
    protected colmecPartnerAgreementsService: ColmecPartnerAgreementsService,
    protected customerService: CustomerService,
    protected translateService: TranslateService
  ) {}

  getFilters(): ConfigBaseFilter<ColmecPartnerAgreement>[] {
    return [
      new ColmecPartnerAgreementCustomerFilter(),
      new ColmecPartnerAgreementPartnerFilter(),
      new ColmecPartnerAgreementStatusFilter(this.translateService)
    ];
  }

  getSortOptions(): ListSortOption<ColmecPartnerAgreement>[] {
    // TODO: implement
    return [];
  }

  getBatchSizes(): number[] {
    return [24];
  }

  getLayouts(): ListLayout<ColmecPartnerAgreement>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => ColmecPartnerAgreementsListViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductGrid'
      }
    ];
  }

  getItems(): Observable<ColmecPartnerAgreement[]> {
    return this.colmecPartnerAgreementsService.getPartnerAgreements();
  }

  getItemId(item: ColmecPartnerAgreement) {
    return item.id;
  }

  getSearchTerms(item: ColmecPartnerAgreement) {
    return [item.id, item.name, item.customerName, item.partnerName];
  }
}

export class ColmecPartnerAgreementCustomerFilter extends SimpleConfigBaseFilter<ColmecPartnerAgreement> {
  constructor() {
    super();
  }

  getName(): string {
    return 'CUSTOMER';
  }

  getOptionIds(item: ColmecPartnerAgreement): string[] {
    return [item.customerName || 'UNDEFINED'];
  }

  getOptionName(key: string): string {
    return key;
  }
}

export class ColmecPartnerAgreementPartnerFilter extends SimpleConfigBaseFilter<ColmecPartnerAgreement> {
  constructor() {
    super();
  }

  getName(): string {
    return 'PARTNER';
  }

  getOptionIds(item: ColmecPartnerAgreement): string[] {
    return [item.partnerName || 'UNDEFINED'];
  }

  getOptionName(key: string): string {
    return key;
  }
}

export class ColmecPartnerAgreementStatusFilter extends SimpleConfigBaseFilter<ColmecPartnerAgreement> {
  constructor(protected translateService: TranslateService) {
    super();
  }

  getName(): string {
    return 'STATUS';
  }

  getOptionIds(item: ColmecPartnerAgreement): string[] {
    return [item.status || 'UNDEFINED'];
  }

  getOptionName(key: string): string {
    return this.translateService.instant(key);
  }
}